import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

const BannerContainer = styled(Box)(({ height, bgColor }) => ({
  display: 'flex',
  justifyContent: 'space-between', // text left, image right
  alignItems: 'flex-start',        // text aligned to top
  height: height,
  backgroundColor: bgColor || '#142434',
  position: 'relative',
  overflow: 'hidden',
  flexWrap: 'wrap',                // allow wrapping on smaller screens
}));

const BannerContent = styled(Box)({
  zIndex: 2,             // text above image
  marginLeft: '32px',    // distance from left edge
  marginTop: '32px',     // title 32px from top
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
});

const HeroBanner = ({ heroTitle, heroDescription, imageUrl, height = '280px' }) => {
  return (
    <BannerContainer height={height}>
      <BannerContent>
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 400,
            fontSize: { xs: '24px', sm: '28px', md: '32px' }, // responsive font size
            color: '#ffffff',
            lineHeight: 1.2,
          }}
        >
          {heroTitle}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'PT Sans, sans-serif',
            fontWeight: 400,
            fontSize: { xs: '14px', sm: '16px' },
            color: '#ffffff',
            marginTop: '12px',
            lineHeight: 1.4,
          }}
        >
          {heroDescription}
        </Typography>
      </BannerContent>

      {imageUrl && (
        <Box
          component="img"
          src={imageUrl}
          alt="Hero Banner"
          sx={{
            zIndex: 1,
            height: { xs: '165px', sm: '165px', md: '100%' }, // max height on small screens
            objectFit: 'contain',
            alignSelf: { xs: 'flex-end', sm: 'flex-end', md: 'flex-start' }, // align bottom on small screens
            marginRight: { xs: '16px', sm: '24px', md: '32px' },
          }}
        />
      )}
    </BannerContainer>
  );
};

export default HeroBanner;
